  <div class="border-0 px-3 px-md-4 py-1 scroll-container" ref="manage_workflow">
    <NavigationBackButton />

    <div class="custom-header shadow-2 rounded-lg mt-3">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <p class="p-3 fw-bold text-white mb-0">Resolved Request Details</p>
        </div>
      </div>
    </div>

    <div class="glassy-bg rounded-lg shadow-sm mt-2">

      <!-- Request and Resolution Details -->
      <div class="row mt-2 p-3 g-3 ">

        <!-- Request Information -->
        <div class="col-12 col-md-6">
          <div class="glassy-bg rounded-lg h-100 shadow-sm">
            <div class="card-body p-4">
              <h6 class="fw-bold mb-2">Request Information</h6>
              <hr class="opacity-25 mt-0">
              <div class="d-flex flex-column flex-sm-row justify-content-between py-2 border-bottom">
                <span class="text-muted small fw-semibold">Requester</span>
                <span class="small mt-1 mt-sm-0">
                  {{ request_infomation.requested_by_first_name }} {{ request_infomation.requested_by_last_name }}
                </span>
              </div>
              <div class="d-flex flex-column flex-sm-row justify-content-between py-2">
                <span class="text-muted small fw-semibold">Date Requested</span>
                <span class="small mt-1 mt-sm-0">{{ request_infomation.date_created }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Resolution Details -->
        <div class="col-12 col-md-6">
          <div class="glassy-bg rounded-lg h-100 shadow-sm">
            <div class="card-body p-4">
              <h6 class="fw-bold mb-2">Resolution Details</h6>
              <hr class="opacity-25 mt-0">
              <div class="d-flex flex-column flex-sm-row justify-content-between py-2 border-bottom">
                <span class="text-muted small fw-semibold">Resolved By</span>
                <span class="small mt-1 mt-sm-0">
                  {{ request_infomation.resolved_by_first_name }} {{ request_infomation.resolved_by_last_name }}
                </span>
              </div>
              <div class="d-flex flex-column flex-sm-row justify-content-between py-2">
                <span class="text-muted small fw-semibold">Date Resolved</span>
                <span class="small mt-1 mt-sm-0">{{ request_infomation.date_resolved }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Requested Fields -->
      <div class="mb-3 p-1">
        <div class="px-3 py-3">
          <p class="mb-1 text-x fw-bold">Requested Fields</p>
          <p class="text-xs text-muted mb-0 ms-2 ms-md-4">
            <span class="fw-bold">Request message:</span> {{ request_infomation.message }}
          </p>
          <!-- flex-wrap so chips wrap on mobile instead of overflowing -->
          <div class="d-flex flex-wrap gap-2 align-items-start p-2 ms-1 ms-md-3 mt-3">
            <div
              v-for="(item, index) in fields"
              :key="index"
              class="card border rounded-lg shadow-sm px-3 py-2 d-flex flex-row align-items-center gap-2"
            >
              <span class="rounded-circle bg-secondary d-inline-block flex-shrink-0 dot-6"></span>
              <span class="small">{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Submitted Documents -->
      <div class="mb-3 border-0 p-1">
        <div class="text-xxs p-3">
          <p class="text-x fw-bold">Submitted Documents</p>

          <div
            class="d-flex flex-column gap-2"
            :class="{ 'overflow-auto': submitted_documents.length > 3 }"
          >
            <div
              v-for="(doc, index) in submitted_documents"
              :key="index"
              class="card border rounded-lg px-3 py-2 d-flex flex-row align-items-center justify-content-between gap-2"
            >
              <!-- overflow-hidden + text-truncate stops long filenames pushing the button off screen -->
              <div class="d-flex flex-column gap-1 overflow-hidden">
                <span class="fw-bold text-xs text-truncate">{{ doc.name }}</span>
                <span class="text-muted text-xxs">{{ doc.date_created }}</span>
              </div>
              <button
                type="button"
                class="btn btn-primary-dark btn-sm text-xxs shadow flex-shrink-0"
                @click="open_document(doc)"
              >
                View
              </button>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div v-if="preview_modal" @click.self="preview_modal = false">
    <FilePreviewComponent
      :presigned_url="selected_file.presigned_url"
      @close="close_the_file_preview"
      :key="selected_file.presigned_url"
    />
  </div>
